import { render, staticRenderFns } from "./RequestAccessModal.vue?vue&type=template&id=8b59c1ba&"
import script from "./RequestAccessModal.vue?vue&type=script&lang=js&"
export * from "./RequestAccessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports